module.exports = __webpack_public_path__ + "img/d.2e0189c6.svg";